import React, { useState, useEffect, useRef } from 'react';
import { bool, string, func, oneOfType, shape } from 'prop-types';

import { OpenedEyeIcon, ClosedEyeIcon } from '@snapask/common-components';

import styles from './LineInput.scss';
import ImeEnhancer from '../ImeEnhancer';
import useShowPassword from './useShowPassword';
const cx = require('classnames/bind').bind(styles);

const LineInput = ({
  autoComplete,
  className,
  disabled,
  errorText,
  floatingLabelText,
  isFocussed,
  isPhoneField,
  meta: { error, invalid },
  type,
  value: initialValue,
  onBlur,
  onChange,
  onFocus,
}) => {
  const [value, setValue] = useState(initialValue);
  const inputRef = useRef();
  const {
    isPassword,
    isCurrentOpen,
    currentType,
    onBlurInput,
    toggleShowPassword,
  } = useShowPassword({
    currentInput: inputRef.current,
    type,
  });

  useEffect(() => {
    if (isFocussed) {
      inputRef.current.focus();
    }
  }, [isFocussed]);

  const handleChange = evt => {
    const { value } = evt.target;
    if (value && isPhoneField && !/^\d+$/.test(value)) {
      return;
    }

    setValue(value);
    onChange(value, evt);
  };

  const handleBlur = e => {
    isPassword && onBlurInput(e);
    onBlur(e);
  };

  return (
    <div
      className={cx('root', className, {
        [styles.error]: disabled,
        [styles.error]: errorText || invalid,
      })}
    >
      <input
        className={cx({ [styles.dirty]: value, [styles.password]: isPassword })}
        type={isPassword ? currentType : type}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={onFocus}
        value={value}
        disabled={disabled}
        ref={inputRef}
        autoComplete={autoComplete}
      />
      {isPassword && (
        <div className={styles.eye} onClick={toggleShowPassword}>
          {isCurrentOpen ? (
            <ClosedEyeIcon width={16} height={16} />
          ) : (
            <OpenedEyeIcon width={16} height={16} />
          )}
        </div>
      )}
      <span className={styles.bar} />
      <label>{floatingLabelText}</label>
      {(errorText || error) && (
        <p className={styles.error}>{errorText || error}</p>
      )}
    </div>
  );
};

LineInput.propTypes = {
  autoComplete: string,
  className: string,
  disabled: bool,
  errorText: oneOfType([bool, string]),
  floatingLabelText: string,
  isFocussed: bool,
  isPhoneField: bool,
  meta: shape({
    error: string,
    invalid: bool,
  }),
  type: string,
  value: string,
  onBlur: func,
  onChange: func,
  onFocus: func,
};

LineInput.defaultProps = {
  autoComplete: 'off',
  disabled: false,
  floatingLabelText: '',
  isFocussed: false,
  isPhoneField: false,
  meta: {
    error: '',
    invalid: false,
  },
  value: '',
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
  type: 'text',
  errorText: false,
  className: '',
};

export { LineInput };
export default ImeEnhancer(LineInput);



// WEBPACK FOOTER //
// ./app/components/fields/LineInput/LineInput.jsx